import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message, notification} from "antd";
import {AUTH_NOMOR_PENDAFTARAN, AUTH_TOKEN} from "../../constants/AuthConstant";
import DokumenService from "../../services/DokumenService";
import SyaratDaftarService from "../../services/SyaratDaftarService";

export const initialState = {
    loading: false,
    dataDokumen: [],
    showMessage:false,
    message:'',
    loadingDelDokumen:false,
    statusDelDokumen:false,
    loadingCekSyarat:false,
    statusCekSyarat:false,
    loadingDataDokumen: false,
    dataFile:'',
    loadingDataFile:false,
    dataFileHasil:'',
    loadingDataHasilFile:false
}


export const postDokumen = createAsyncThunk('transaksi/dokumen/pendaftar',async (data, { rejectWithValue }) => {
    const {id_pendaftar,nama_file}=data;
    try {
        const response = await DokumenService.postDokumen(localStorage.getItem(AUTH_TOKEN),{id_pendaftar,nama_file,keterangan:'upload'})
        //console.log(JSON.stringify(response))
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const delDokumen = createAsyncThunk('transaksi/dokumen/delete',async (data, { rejectWithValue }) => {
    const {id_dokumen_pendaftar}=data;
    try {
        const response = await DokumenService.delDokumen(localStorage.getItem(AUTH_TOKEN),id_dokumen_pendaftar)
        if(response.success!=true){
            message.error(response.message??'error',3)
        }
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const cekSyarat = createAsyncThunk('transaksi/dokumen/ceksyarat',async (data, { rejectWithValue }) => {
    //const navigate=useNavigate();
    try {
        const response = await DokumenService.cekSyaratDokumen(localStorage.getItem(AUTH_TOKEN),{id_pendaftar:localStorage.getItem(AUTH_NOMOR_PENDAFTARAN)})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            notification.error({
                message: 'Perhatian',
                className:"text-danger",
                description:
                    `${response.message}`,
                duration:5
            });
            //message.error(response.message??'error',3)
        }
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataDokumenPendaftar = createAsyncThunk('transaksi/dokumen/data',async (data, { rejectWithValue }) => {
    const {id_pendaftar}=data;
    try {
        const response = await SyaratDaftarService.getDataByID(localStorage.getItem(AUTH_TOKEN),id_pendaftar)
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            return response
        }
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataFile = createAsyncThunk('transaksi/dokumen/file',async (data, { rejectWithValue }) => {
    const {id_dokumen_pendaftar,id_pendaftar}=data;
    try {
        const response = await DokumenService.viewFile(localStorage.getItem(AUTH_TOKEN),id_pendaftar,id_dokumen_pendaftar)
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            return response
        }
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataFileHasil = createAsyncThunk('transaksi/dokumen/hasil',async (data, { rejectWithValue }) => {
    const {tipe}=data;
    try {
        const response = await DokumenService.hasilSeleksi(localStorage.getItem(AUTH_TOKEN),tipe)
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            return true
        }
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const dokumenSlice = createSlice({
    name: 'dokumen',
    initialState,
    reducers: {
        dokumenSuccess: (state, action) => {
            state.loading = false
            state.dataDokumen = action.payload
        },
        showLoadingDokumen: (state) => {
            state.loading = true
        },
        delDokumenSuccess: (state, action) => {
            state.loadingDelDokumen = false
            state.statusDelDokumen = action.payload.success
        },
        cekSyaratSuccess: (state, action) => {
            state.loadingCekSyarat = false
            state.statusCekSyarat = action.payload.success
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(postDokumen.fulfilled, (state, action) => {
                state.loading = false
                state.dataDokumen = action.payload
            })
            .addCase(postDokumen.pending, (state) => {
                state.loading = true
            })
            .addCase(postDokumen.rejected, (state, action) => {
                state.loading = false
                state.dataDokumen = action.payload
            })
            .addCase(delDokumen.fulfilled, (state, action) => {
                state.loadingDelDokumen = false
                state.statusDelDokumen = action.payload.success
            })
            .addCase(delDokumen.pending, (state) => {
                state.loadingDelDokumen = true
            })
            .addCase(delDokumen.rejected, (state, action) => {
                state.loadingDelDokumen = false
                state.statusDelDokumen = action.payload.success
            })
            .addCase(cekSyarat.fulfilled, (state, action) => {
                state.loadingCekSyarat = false
                state.statusCekSyarat = action.payload.success
            })
            .addCase(cekSyarat.pending, (state) => {
                state.loadingCekSyarat = true
            })
            .addCase(cekSyarat.rejected, (state, action) => {
                state.loadingCekSyarat = false
            })
            .addCase(getDataDokumenPendaftar.fulfilled, (state, action) => {
                state.dataDokumen = action.payload
                state.loadingDataDokumen=false
            })
            .addCase(getDataDokumenPendaftar.pending, (state) => {
                state.loadingDataDokumen=true
            })
            .addCase(getDataDokumenPendaftar.rejected, (state, action) => {
                state.dataDokumen = action.payload
                state.loadingDataDokumen=false
            })
            .addCase(getDataFile.fulfilled, (state, action) => {
                state.dataFile = action.payload
                state.loadingDataFile=false
            })
            .addCase(getDataFile.pending, (state) => {
                state.loadingDataFile=true
            })
            .addCase(getDataFile.rejected, (state, action) => {
                state.dataFile = action.payload
                state.loadingDataFile=false
            })
            .addCase(getDataFileHasil.fulfilled, (state, action) => {
                state.dataFileHasil = action.payload
                state.loadingDataHasilFile=false
            })
            .addCase(getDataFileHasil.pending, (state) => {
                state.loadingDataHasilFile=true
            })
            .addCase(getDataFileHasil.rejected, (state, action) => {
                state.dataFileHasil = action.payload
                state.loadingDataHasilFile=false
            })
    },
})

export const {
  dokumenSuccess,
  showLoadingDokumen,
    delDokumenSuccess,
    cekSyaratSuccess
} = dokumenSlice.actions

export default dokumenSlice.reducer
